import PCCCertificate from "../pcc/PCCCertificate";
import {
  useAcknowledgeCertificateDisclaimer,
  useGetCertificates,
} from "@/hooks/compliance/compliance.hook";
import { ECertificateStatus } from "@/constants/enums/certificate-status.enum";
import { useState } from "react";
import {
  CertificateDownloadDialog,
  hasCertificateDisclaimerAck,
  setCertificateDisclaimerAck,
} from "./CertificateDownloadDialog";
import { PencomConstants } from "@/constants/PencomConstants";
import { toast } from "@/utils/toast";

const PCCCertificateDisplay = () => {
    const { data: certificates } = useGetCertificates(ECertificateStatus.ACTIVE);
    const currentCertificate = certificates?.[0];
    const [disclaimerOpen, setDisclaimerOpen] = useState(false);

    const { mutateAsync: acknowledgeDisclaimer, isPending: isAcknowledging } =
        useAcknowledgeCertificateDisclaimer();

    const handlePrint = () => {
        window.print();
    };

    const handleDownloadClick = () => {
        if (hasCertificateDisclaimerAck()) {
            window.print();
            return;
        }
        setDisclaimerOpen(true);
    };

    const handleDisclaimerConfirm = async () => {
        if (currentCertificate?.id) {
            try {
                await acknowledgeDisclaimer({
                    id: currentCertificate.id,
                    disclaimerVersion: PencomConstants.CERTIFICATE_DISCLAIMER_VERSION,
                });
            } catch {
                if (PencomConstants.CERTIFICATE_DISCLAIMER_FAIL_CLOSED) {
                    toast.error("Could not record acknowledgment. Please try again.");
                    return;
                }
            }
        }
        setCertificateDisclaimerAck();
        setDisclaimerOpen(false);
        window.print();
    };

    return (
        <>
        <CertificateDownloadDialog
            open={disclaimerOpen}
            onOpenChange={setDisclaimerOpen}
            onConfirm={() => void handleDisclaimerConfirm()}
            isConfirming={isAcknowledging}
        />
        <div className="flex flex-col items-center">
            {/* Certificate Container - Centered */}
            <div className="certificate-container flex justify-center w-full mb-8">
                <PCCCertificate
                    certificateNumber={currentCertificate?.id}
                    issueDate={currentCertificate?.issue_date}
                    expiryDate={currentCertificate?.expiry_date}
                />
            </div>

            {/* Action Buttons - Below Certificate */}
            <div className="flex flex-row gap-x-4 no-print mb-8">
                <button
                    onClick={handlePrint}
                    className="px-8 py-3 bg-primary-button text-white rounded-lg font-clash-display font-semibold hover:bg-light-primary-button transition-colors"
                >
                    Print Certificate
                </button>
                <button
                    onClick={handleDownloadClick}
                    className="px-8 py-3 bg-primary-button text-white rounded-lg font-clash-display font-semibold hover:bg-light-primary-button transition-colors"
                >
                    Download as PDF
                </button>
            </div>
        </div>
        </>
    );
};

export default PCCCertificateDisplay;